import React, { useEffect, useState } from 'react';
import { Inbox, Loader2, MessageSquare } from 'lucide-react';
import client from '../../lib/api';
import { accountHook } from '../../lib/domHooks';

const formatDate = (value) => {
  if (!value) return '';
  return new Date(value).toLocaleString('tr-TR', {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
};

const Messages = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client.get('/messages')
      .then(({ data }) => setMessages(data.items || []))
      .catch(() => setMessages([]))
      .finally(() => setLoading(false));
  }, []);

  const markRead = async (message) => {
    if (message.is_read) return;
    await client.patch(`/messages/${message.id}/read`);
    setMessages((items) => items.map((item) => (
      item.id === message.id ? { ...item, is_read: true } : item
    )));
  };

  const unread = messages.filter((message) => !message.is_read).length;

  return (
    <div className="pusu-panel p-6" {...accountHook('panel')}>
      <div className="flex items-center gap-3 mb-5" {...accountHook('page-header')}>
        <MessageSquare size={20} className="text-[var(--pusu-gold)]" />
        <h2 className="text-xl font-bold gold-text" {...accountHook('title')}>Mesajlarım</h2>
        <span className="ml-auto text-xs text-gray-400" {...accountHook('summary')}>{unread} okunmamış</span>
      </div>
      {loading ? (
        <div className="text-center py-10 text-gray-400" {...accountHook('loading')}>
          <Loader2 className="inline animate-spin mr-2" size={18} /> Yükleniyor...
        </div>
      ) : messages.length === 0 ? (
        <div className="text-center py-10" {...accountHook('empty')}>
          <Inbox size={40} className="mx-auto text-gray-600" />
          <p className="text-gray-500 mt-2">Henüz mesajınız yok</p>
        </div>
      ) : (
        <div className="space-y-2" {...accountHook('list')}>
          {messages.map((message) => (
            <button
              type="button"
              key={message.id}
              onClick={() => markRead(message)}
              data-bhs-status={message.is_read ? 'read' : 'unread'}
              {...accountHook('message')}
              className={`pusu-card p-4 cursor-pointer hover:border-[var(--pusu-gold)]/40 w-full text-left ${!message.is_read ? 'border-[var(--pusu-gold)]/40' : ''}`}
            >
              <div className="flex items-start gap-3">
                <div className={`w-2 h-2 rounded-full mt-2 ${!message.is_read ? 'bg-[var(--pusu-gold)]' : 'bg-gray-600'}`} />
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <div className={`font-semibold text-sm ${!message.is_read ? 'text-white' : 'text-gray-400'}`}>{message.subject}</div>
                    <div className="text-xs text-gray-500 ml-auto">{formatDate(message.created_at)}</div>
                  </div>
                  <p className="text-sm text-gray-400 mt-1 whitespace-pre-wrap">{message.body}</p>
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default Messages;
